module.exports = __webpack_public_path__ + "media/images/ceremony/top/ceremony-top-main-7b94ee9ee9f8a112527f1b5a4f60f010.jpg";